import {z} from 'zod';

export const WorkshopInterestSeriesDefinitionResponseBodySchema = z.object({
  id: z.string(),
  name: z.string(),
  branchId: z.string().nullable(),
  seriesId: z.string(),
  isSystem: z.boolean(),
});

export type WorkshopInterestSeriesDefinitionResponseBody = z.infer<
  typeof WorkshopInterestSeriesDefinitionResponseBodySchema
>;

export const GetWorkshopInterestSeriesDefinitionListApiResponseSchema = z.array(
  WorkshopInterestSeriesDefinitionResponseBodySchema
);

export const GetWorkshopInterestSeriesDefinitionListApiArgSchema = z.void();

export type GetWorkshopInterestSeriesDefinitionListApiArg = z.infer<
  typeof GetWorkshopInterestSeriesDefinitionListApiArgSchema
>;

export type GetWorkshopInterestSeriesDefinitionListApiResponse =
  WorkshopInterestSeriesDefinitionResponseBody[];

export const GetWorkshopInterestSeriesDefinitionApiArgSchema = z.object({
  seriesDefinitionId: z.string(),
});

export type GetWorkshopInterestSeriesDefinitionApiArg = z.infer<
  typeof GetWorkshopInterestSeriesDefinitionApiArgSchema
>;

export type GetWorkshopInterestSeriesDefinitionApiResponse =
  WorkshopInterestSeriesDefinitionResponseBody;

export const CreateWorkshopInterestSeriesDefinitionRequestBodySchema = z.object({
  name: z.string(),
  seriesId: z.string(),
  branchId: z.string(),
});

export type CreateWorkshopInterestSeriesDefinitionRequestBody = z.infer<
  typeof CreateWorkshopInterestSeriesDefinitionRequestBodySchema
>;

export type CreateWorkshopInterestSeriesDefinitionApiArg = {
  createWorkshopInterestSeriesDefinitionRequestBody: CreateWorkshopInterestSeriesDefinitionRequestBody;
};

export type CreateWorkshopInterestSeriesDefinitionApiResponse =
  WorkshopInterestSeriesDefinitionResponseBody;

export const PutWorkshopInterestSeriesDefinitionRequestBodySchema = z.object({
  name: z.string(),
  seriesId: z.string(),
  branchId: z.string().nullable(),
});

export type PutWorkshopInterestSeriesDefinitionRequestBody = z.infer<
  typeof PutWorkshopInterestSeriesDefinitionRequestBodySchema
>;

export const PutWorkshopInterestSeriesDefinitionApiArgSchema = z.object({
  seriesDefinitionId: z.string(),
  putWorkshopInterestSeriesDefinitionRequestBody:
    PutWorkshopInterestSeriesDefinitionRequestBodySchema,
});

export type PutWorkshopInterestSeriesDefinitionApiArg = z.infer<
  typeof PutWorkshopInterestSeriesDefinitionApiArgSchema
>;

export type PutWorkshopInterestSeriesDefinitionApiResponse =
  WorkshopInterestSeriesDefinitionResponseBody;
